export default __webpack_public_path__ + "static/media/yt1.90c15352.svg";